import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { css } from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import '../../node_modules/react-custom-scrollbars-2/lib/index.js';
import styled from 'styled-components';
import { __exports as lib } from '../../_virtual/index3.js';
var Thumb = styled.div(css({
  backgroundColor: "grey.5",
  borderRadius: "16px",
  width: "4px",
  cursor: "pointer"
}));
var VerticalTrack = styled.div(css({
  right: "8px !important",
  width: "4px !important",
  bottom: 24,
  top: 2
}));
var Scrollbars = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(lib.Scrollbars, __assign({
    autoHeight: true,
    autoHide: true,
    renderThumbVertical: function renderThumbVertical(thumbProps) {
      return React__default.createElement(Thumb, __assign({}, thumbProps));
    },
    renderTrackVertical: function renderTrackVertical(trackProps) {
      return React__default.createElement(VerticalTrack, __assign({}, trackProps));
    }
  }, props, {
    ref: ref
  }));
});
export { Scrollbars };